export const SET_FEED = 'SET_FEED'
export const RESET_FEED = 'RESET_FEED'
export const RESET_FEED_POST = 'RESET_FEED_POST'
export const RESET_COMMENT = 'RESET_COMMENT'
export const SET_FEED_POST = 'SET_FEED_POST'
export const SET_PAGER = 'SET_PAGER'
export const SET_FEED_POST_LIKE = 'SET_FEED_POST_LIKE'
export const SET_FEED_POST_DATA = 'SET_FEED_POST_DATA'
export const SET_COMMENT_DATA = 'SET_COMMENT_DATA'
export const SET_COMMENT = 'SET_COMMENT'

export const STORE_PAGER = 'feed/pager'
